import 'react-app-polyfill/ie11'; // This must be the first line
import 'react-app-polyfill/stable';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import App from './App';
import store from './app/store';

ReactDOM.render(
  <Suspense fallback={<div>Loading</div>}>
    <App />
  </Suspense>,
  document.getElementById('root')
);

// Expose the Redux store to Cypress tests
if (window.Cypress) {
  window.store = store;
}
